'use client';
import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const AuthFormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.LG}rem;
`;
